import { NavItem } from '@billy/design-system'

import { NavigationVariant } from '../types/navigationVariant'

export const toNavItemVariant = (variant: NavigationVariant): NavItem['variant'] =>
  variant === 'inverted' ? 'inverted' : undefined
